<template>
  <div class="row mb-3">
    <div class="col-8">
      <i-input
        suffix="ios-search"
        :placeholder="$t(`shared.component.filter.search`)"
        :clearable="true"
        :value="value"
        v-on="$listeners"
      />
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: [String],
        default: ''
      }
    }
  };
</script>
